import React, { useState, useEffect } from 'react';
import UserVenteListTable from './VenteChargeListTable';
import VenteListCard from '../vente_list/VenteListCard';
import { getSocietes } from '../../flux/actions/societeActions';
import { getUsers } from '../../flux/actions/userActions';
import { getVentesByCharge, clearVentes } from '../../flux/actions/venteActions';
import { getAssociationsByCharge, clearAssociations } from '../../flux/actions/associationActions';
import { Container, Row, Col, Label, CustomInput } from 'reactstrap';

import { connect } from 'react-redux';
import { IVenteChargeListContainer, IVenteChargeListReduxProps } from '../../types/interfaces';
import LoadingPage from '../../pages/loading';
import Loading from '../Loading';
import { PRIVILEGE } from '../../types/privileges'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faBoxOpen, faHouseUser, faUserTag } from '@fortawesome/free-solid-svg-icons'
import Select from 'react-select';
import Durations from '../Durations';
import { constants } from '../../types/constants';
import { useParams } from "react-router-dom";

const VenteChargeListContainerComponent = ({
  getSocietes,
  getUsers,
  getVentesByCharge,
  clearVentes,
  getAssociationsByCharge,
  clearAssociations,
  societe,
  user,
  vente,
  association,
  // samiFlag,
  auth
 }: IVenteChargeListContainer) => {
  let { project: projectIdTarget, user: userIdTarget } = useParams();

  const { users, loading: loadingU } = user;
  const { societes, loading: loadingS } = societe;
  const { ventes, loading } = vente;
  const { associations, loading: loadingA } = association;
  const [ventesAndAssociations, setVentesAndAssociations] = useState([...ventes, ...associations.map(e => ({...e, vente: e.contrat, isAssLine: true}))].sort((a, b) => {
    if(!a.createdAt && !b.createdAt)
      return 0
    else if(!a.createdAt)
      return 1
    else if(!b.createdAt)
      return -1
    else
      return a.createdAt > b.createdAt ? -1 : a.createdAt < b.createdAt ? 1 : 0
  }));
  const [tableData, setTableData] = useState(ventesAndAssociations);
  const [filteredRows, setFilteredRows] = useState(ventesAndAssociations);
  const selectOptions = [{value: {id: "ALL", LIBELE: "Tous les projets"}, label: "Tous les projets"}, ...societes.map(e => ({value: e, label: e.LIBELE}))];
  const [selectedValue, setSelectedValue] = useState<any>('');
  // const userOptions = users.map(e => ({value: e, label: e.username}));
  const userOptions = (auth?.user?.privileges?.includes(PRIVILEGE.ACCESS_ALL_USERS) ? [{id: "ALL", LOGIN: "Tout"}, ...users.map(e => ({id: e.id, LOGIN: e.username}))] : [{id: auth?.user?.id, LOGIN: auth?.user?.username}]).map(e => ({value: e.id, label: e["LOGIN"] || e["username"], user: e}));
  // const userOptions = [...(auth?.user?.underlings?.filter(e => e.id !== auth.user.id).length ? [{id: "ALL", LOGIN: "Tout"}] : []), {id: auth?.user?.id, LOGIN: auth?.user?.username}, ...(auth?.user?.underlings?.filter(e => e.id !== auth.user.id) || [])].map(e => ({value: e.id, label: e["LOGIN"], user: e}));
  const [selectedUser, setSelectedUser] = useState<any>('');
  const titledOptions = [{value: "ALL", label: "Tout"}, {value: "TITLED", label: "Titrés"}, {value: "UNTITLED", label: "Non titrés"}];
  const [titledValue, setTitledValue] = useState<any>(titledOptions.find(e => e.value === "ALL"));
  const sNotaireOptions = [{value: "NOT YET", label: "Pas encore signé"}, {value: "CHEZ", label: "Signé client"}, {value: "EN COURS", label: "Signature en cours"}, {value: "SIGNE", label: "Signé notaire"}];
  const [sNotaireValues, setSNotaireValues] = useState<any[]>(sNotaireOptions.filter(e => ["NOT YET", "CHEZ", "EN COURS", "SIGNE"].includes(e.value)));
  const [selectedDuration, setSelectedDuration] = useState('');
  const [showAllAssociationsValue, setShowAllAssociationsValue] = useState(true);

  useEffect(() => {
    setVentesAndAssociations([...ventes, ...associations.map(e => ({...e, vente: e.contrat, isAssLine: true}))]
    .filter(e => sNotaireValues.some(e => e.value === "NOT YET") || (e["isAssLine"] ? e["contrat"]?.bien?.STATUT : e["bien"]?.STATUT) === constants.STATUT_SIGNE_NOTAIRE || !!(e["isAssLine"] ? e["contrat"]?.en_cours_signature : e["en_cours_signature"]) || !!(e["isAssLine"] ? e["contrat"]?.chez_notaire : e["chez_notaire"]))
    .filter(e => sNotaireValues.some(e => e.value === "CHEZ") || (e["isAssLine"] ? e["contrat"]?.bien?.STATUT : e["bien"]?.STATUT) === constants.STATUT_SIGNE_NOTAIRE || (e["isAssLine"] ? e["contrat"]?.en_cours_signature : e["en_cours_signature"]) || !(e["isAssLine"] ? e["contrat"]?.chez_notaire : e["chez_notaire"]))
    .filter(e => sNotaireValues.some(e => e.value === "EN COURS") || (e["isAssLine"] ? e["contrat"]?.bien?.STATUT : e["bien"]?.STATUT) === constants.STATUT_SIGNE_NOTAIRE || !(e["isAssLine"] ? e["contrat"]?.en_cours_signature : e["en_cours_signature"]))
    .filter(e => sNotaireValues.some(e => e.value === "SIGNE") || (e["isAssLine"] ? e["contrat"]?.bien?.STATUT : e["bien"]?.STATUT) !== constants.STATUT_SIGNE_NOTAIRE)
      .sort((a, b) => {
      if(!a.createdAt && !b.createdAt)
        return 0
      else if(!a.createdAt)
        return 1
      else if(!b.createdAt)
        return -1
      else
        return a.createdAt > b.createdAt ? -1 : a.createdAt < b.createdAt ? 1 : 0
    }))
  }, [ventes, associations, sNotaireValues])

  const changeShowAllAssociationsHandle = (e) => {
    setShowAllAssociationsValue(e.target.checked);
    // if(e.target.checked)
    //   setSelectedDuration('')
  };

  useEffect(() => {
    auth && auth.user && getSocietes(auth?.user.societes?.map(e => e.id) || []/*, !!auth.user.privileges?.includes(PRIVILEGE.FULL_MENU)*/);
  }, [getSocietes, auth]);

  // useEffect(() => {
  //   if(auth?.user?.id !== undefined && selectedUser === '')
  //     setSelectedUser(userOptions.find(e => e.user.id === auth.user.id)?.user || '')
  // }, [auth?.user?.id, userOptions]);

  useEffect(() => {
    if(selectedUser === ''){
      let choosenId: any = undefined;
      if(userIdTarget !== undefined)
        choosenId = userIdTarget
      else if(auth?.user?.id !== undefined)
        choosenId = auth.user.id
      if(choosenId !== undefined)
        setSelectedUser((choosenId == -1 ? (auth?.user?.privileges?.includes(PRIVILEGE.ACCESS_ALL_USERS) ? userOptions.find(e => e.value === "ALL")?.user : undefined) : userOptions.find(e => e.user.id == choosenId)?.user) || '')
    }
  }, [auth?.user, userOptions]);

  // useEffect(() => {
  //   if(societes && societes.length){
  //     if(auth && auth.user){
  //       for(let so of societes)
  //         if(so.id == auth.user.last_societe){
  //           setSelectedValue(so);
  //           break
  //         }
  //     }
  //   }
  // }, [societes]);

  useEffect(() => {
    if(!selectedValue && societes?.length){
      let choosenId: any = undefined;
      if(projectIdTarget !== undefined)
        choosenId = projectIdTarget
      else if(auth && auth.user)
        choosenId = auth.user.last_societe
      if(choosenId !== undefined){
        if(choosenId == -1)
          setSelectedValue(selectOptions.find(e => e.value.id === "ALL")?.value)
        else
          for(let so of societes)
            if(so.id == choosenId){
              setSelectedValue(so);
              break
            }
      }
    }
  }, [societes]);

  useEffect(() => {
    clearVentes();
    clearAssociations();
    if(selectedValue && auth?.user && selectedUser){
      getVentesByCharge(selectedDuration, selectedUser.id === "ALL" ? ((auth?.user?.privileges?.includes(PRIVILEGE.ACCESS_ALL_USERS) ? users : auth.user.underlings)?.map(e => e.id) || []) : [selectedUser.id], selectedUser.id === "ALL" && !!auth?.user?.privileges?.includes(PRIVILEGE.ACCESS_ALL_USERS) ? 1 : 0, (titledValue || titledOptions[1]).value, 0, showAllAssociationsValue ? 1 : 0, selectedValue["id"] === "ALL" ? "ALL" : selectedValue["id"], selectedValue["LIBELE"], auth?.user.societes || []);
      if(showAllAssociationsValue)
        getAssociationsByCharge(selectedDuration, selectedUser.id === "ALL" ? ((auth?.user?.privileges?.includes(PRIVILEGE.ACCESS_ALL_USERS) ? users : auth.user.underlings)?.map(e => e.id) || []) : [selectedUser.id], selectedUser.id === "ALL" && !!auth?.user?.privileges?.includes(PRIVILEGE.ACCESS_ALL_USERS) ? 1 : 0, (titledValue || titledOptions[1]).value, 0, selectedValue["id"] === "ALL" ? "ALL" : selectedValue["id"], selectedValue["LIBELE"], auth?.user.societes || []);
    }
      // getVentesByCharge(selectedDuration, auth.user.id || -1, selectedValue["id"] === "ALL" ? "ALL" : selectedValue["id"], selectedValue["LIBELE"], auth?.user.societes || []/*, !!auth.user.privileges?.includes(PRIVILEGE.FULL_MENU)*/);
  }, [/*getVentesByCharge, getAssociationsByCharge, */selectedValue, auth, selectedDuration, titledValue, selectedUser, showAllAssociationsValue]);

  useEffect(() => {
    return () => {
      clearVentes();
      clearAssociations();
    }
  }, []);

  // useEffect(() => {console.log("ventes", ventes?.length ? ventes[0] : null)
  //   const associationVentes = ventes.filter(e => e.TYPE_VENTE === "ASSOCIATION");
  //   const lines: any[] = ventes.filter(e => e.TYPE_VENTE !== "ASSOCIATION");
  //   for(let i in associationVentes){
  //     const associations = associationVentes[i].associations || [];
  //     for(let j in associations)
  //       lines.push({...associations[j], vente: associationVentes[i], isAssLine: true})
  //   }
  //   setTableData((showAllAssociationsValue ? lines : [...ventes]).sort((a, b) => {
  //     if(!a.createdAt && !b.createdAt)
  //       return 0
  //     else if(!a.createdAt)
  //       return 1
  //     else if(!b.createdAt)
  //       return -1
  //     else
  //       return a.createdAt > b.createdAt ? -1 : a.createdAt < b.createdAt ? 1 : 0
  //   }));
  // }, [ventes, showAllAssociationsValue]);

  useEffect(() => {
    setTableData(ventesAndAssociations);
  }, [ventesAndAssociations]);

  useEffect(() => console.log("tableData", tableData), [tableData])
  
  const handleSelectChange = data => {
    setSelectedValue(data ? data.value : '');
  }
  const handleUserChange = data => {
    setSelectedUser(data ? data.user : '');
  }
  const handleTitledChange = data => {
    setTitledValue(data || '');
  }
  const handleSNotaireChange = data => {
    setSNotaireValues(data?.length ? data : []);
  }

  const filterOptions = (e, input) => {
    if(!e.value)
      return false;
    const filterWords = input.trim().split(' ');
    
    if(filterWords.length){
      let allWordsMatch = true;
      for(let word of filterWords){
        word = word.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
        if(!e.value.LIBELE || !e.value.LIBELE.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "").includes(word))
          allWordsMatch = false
      }
      return allWordsMatch
    }
    
    return true;
  }

  return !auth?.user ? <LoadingPage/> : (
    <>
      <Container>
        <Row style={{marginBottom: "5px"}}>
          <Col xs="12" lg="6"><h4 className="title"><FontAwesomeIcon icon={faUserTag} />&nbsp;&nbsp;Recouvrement par chargé</h4></Col>
          <Col sm="12" md="3" lg="2" className="listPageFilterTitle">
            <Label for="societe">Projet : </Label>
          </Col>
          <Col sm="12" md="9" lg="4" className="listPageFilterSelect">
              <Select
                name="reactselect"
                className="reactselect"
                classNamePrefix="react-select"
                id="societe"
                value={selectedValue ? {label: selectedValue["LIBELE"], value: selectedValue} : null}
                onChange={handleSelectChange}
                placeholder={'Chercher par projet...'}
                isClearable={true}
                isLoading={loadingS}
                loadingMessage={() => 'Chargement...'}
                noOptionsMessage={() => 'pas de resultat'}
                isSearchable={true}
                labelKey='LIBELE'
                // valueKey='code'
                options={selectOptions}
                filterOption={filterOptions}
              />
          </Col>
        </Row>
        <Row className="justify-content-between">
          <Col sm="12" lg="4" className="listPageFilterSelect">
            <div className="listPageFilterTitle" style={{padding: "0 8px"}}>
              <Label for="user">Chargé du bien : </Label>
            </div>
            <Select
              name="user"
              className="reactselect"
              classNamePrefix="react-select"
              value={selectedUser ? {label: selectedUser["LOGIN"] || selectedUser["username"], value: selectedUser.id, user: selectedUser} : null}
              onChange={handleUserChange}
              placeholder={'Chercher par nom...'}
              isClearable={false}
              isLoading={loadingU}
              loadingMessage={() => 'Chargement...'}
              noOptionsMessage={() => 'pas de resultat'}
              isSearchable={true}
              // labelKey='LOGIN'
              // valueKey='countryCode'
              options={userOptions}
            />
          </Col>
          {/* <Col sm="12" md="6" lg="3" className="listPageFilterSelect">
            <div className="listPageFilterTitle" style={{padding: "0 8px"}}>
              <Label for="societe">Projet : </Label>
            </div>
            <Select
              name="reactselect"
              className="reactselect"
              classNamePrefix="react-select"
              id="societe"
              value={selectedValue ? {label: selectedValue["LIBELE"], value: selectedValue} : null}
              onChange={handleSelectChange}
              placeholder={'Chercher par projet...'}
              isClearable={true}
              isLoading={loadingS}
              loadingMessage={() => 'Chargement...'}
              noOptionsMessage={() => 'pas de resultat'}
              isSearchable={true}
              labelKey='LIBELE'
              // valueKey='code'
              options={selectOptions}
              filterOption={filterOptions}
            />
          </Col> */}
          <Col sm="12" lg="5" className="listPageFilterSelect">
            <div className="listPageFilterTitle" style={{padding: "0 8px"}}>
              <Label for="snotaire">Statut notaire : </Label>
            </div>
            <Select
              id="snotaire"
              className="reactselect"
              classNamePrefix="react-select"
              isMulti
              value={sNotaireValues || []}
              // value={{value: societeValue.value, label: societeValue.label}}
              onChange={handleSNotaireChange}
              placeholder={'Chercher...'}
              isClearable={false}
              loadingMessage={() => 'Chargement...'}
              noOptionsMessage={() => 'pas de resultat'}
              isSearchable={true}
              options={sNotaireOptions}
              menuContainerStyle={{ zIndex: 9999999 }}
            />
          </Col>
          <Col sm="12" lg="3" className="listPageFilterSelect">
            <div className="listPageFilterTitle" style={{padding: "0 8px"}}>
              <Label for="titled">Titrés : </Label>
            </div>
            <Select
              id="titled"
              className="reactselect"
              classNamePrefix="react-select"
              defaultValue={titledOptions[1]}
              value={titledValue}
              // value={{value: societeValue.value, label: societeValue.label}}
              onChange={handleTitledChange}
              isClearable={false}
              loadingMessage={() => 'Chargement...'}
              noOptionsMessage={() => 'pas de resultat'}
              isSearchable={false}
              options={titledOptions}
            />
          </Col>
        </Row>
      </Container>
      <Container style={{marginTop: "2px"}}>
        <Row className="justify-content-center justify-content-sm-end">
          <CustomInput type="switch" id="showAllAssociations" name="showAllAssociationsSwitch" label="Afficher les parts des associations" checked={showAllAssociationsValue} onChange={changeShowAllAssociationsHandle} />
        </Row>
      </Container>
      <Durations selectedDuration={selectedDuration} setSelectedDuration={setSelectedDuration} style={{marginTop: "2px"}} />
      {/* <Durations selectedDuration={selectedDuration} setSelectedDuration={setSelectedDuration} style={{marginTop: 6"2px", ...(showAllAssociationsValue ? {opacity: .3, pointerEvents: "none"} : {})}} /> */}
      {loading || loadingA ? <Loading topSpace /> : <UserVenteListTable ventesData={tableData} setFilteredRows={setFilteredRows} showProjectColumn={selectedValue?.id === "ALL"} showComColumn={selectedUser?.id === "ALL"} showTitledColumn={titledValue?.value === "ALL"} showSNotaireColumn={true} allAssociationsShown={showAllAssociationsValue} />}
      {loading || loadingA ? null : <VenteListCard allRows={tableData} filteredRows={filteredRows} selectedProjet={selectedValue} flagFlag={true} /*calculateParts={showAllAssociationsValue}*/ />}
    </>
  );
};

const mapStateToProps = (state: IVenteChargeListReduxProps) => ({
  societe: state.societe,
  user: state.user,
  vente: state.vente,
  association: state.association,
  auth: state.auth
});

export default connect(mapStateToProps, { getSocietes, getUsers, getVentesByCharge, clearVentes, getAssociationsByCharge, clearAssociations })(VenteChargeListContainerComponent);
